export default {
  '_b._qhyy': 'Sprache wechseln',

  '_a._jzz': 'Wird geladen...',

  '_a._jzgd': 'Mehr laden',

  '_a._wct': 'Willkommen',

  '_a._gd': 'Mehr',

  '_a._bf': 'Spielen',

  '_a._bcz': 'Speichern...',

  '_a._sctp': 'Bild hochladen',

  '_dl._qssyx': 'Bitte geben Sie Ihre E-Mail-Adresse ein',

  '_dl._qssmm': 'Bitte geben Sie Ihr Passwort ein',

  '_dl._ann': 'Anmelden',

  '_dl._hmyzh': 'Noch kein Konto?',

  '_dl._qzc': 'Registrieren',

  '_dl._yzhl': 'Haben Sie ein Konto?',

  '_dl._qdl': 'Anmelden" in',

  '_dl._srqrmm': 'Bitte geben Sie zur Bestätigung Ihres Passworts ein',
  '_dl._sryqm': 'Bitte geben Sie den Einladungscode ein',

  '_dl._sryzm': 'Bitte geben Sie den Bestätigungscode ein',

  '_dl._ljzc': 'Jetzt registrieren',

  '_dl._zcbsty': 'Mit Ihrer Registrierung bestätigen Sie, dass Sie die Nutzungsbedingungen gelesen haben und ihnen zustimmen',

  '_dl._yszc': 'Datenschutzrichtlinie',

  '_dl._lcmmbyy': 'Die beiden Passwörter stimmen nicht überein',

  '_yzm._fsyzm': 'Bestätigungscode wird gesendet',

  '_yzm._cxfs': '({time}) Erneut senden',

  '_yzm._fsz': 'Wird gesendet...',

  '_yzm._fscg': 'Erfolgreich gesendet',

  '_h._zrm': 'Die meisten Beliebt',

  '_h._zxd': 'Neueste',

  '_h._phb': 'Rangliste',

  '_h._qz': 'Hintergrundbild',
  '_h._ssww': 'Suche',

  '_h._lsjl': 'Verlauf',

  '_h._gd': 'Mehr',

  '_h._dl': 'Anmelden',

  '_h._ye': 'Kontostand',

  '_h._dj': 'Gefroren',

  '_h._ybp': 'Dashboard',

  '_h._wdqb': 'Meine Geldbörse',

  '_h._scjl': 'Favoriten',

  '_h._xxzx': 'Nachrichtencenter',

  '_h._fxhy': 'Mit Freunden teilen',

  '_h._bzzx': 'Hilfecenter',

  '_h._ggtf': 'Werbung',

  '_h._bqtz': 'Copyright-Investition',

  '_h._sz': 'Einstellungen',

  '_sy._jx': 'Empfohlen',

  '_sy._xpfb': 'Neue Produkte',

  '_sy._gdsp': 'Weitere Videos',

  '_qz._jbqz': 'Schöne Wallpaper-Sammlung',

  '_qz._ssqz': 'Wallpaper suchen',

  '_qz._qb': 'Alle',

  '_qz._zrfg': 'Naturlandschaften',

  '_qz._cxys': 'Abstrakte Kunst',

  '_qz._csjz': 'Stadtarchitektur',

  '_qz._dmyx': 'Anime & Spiele',

  '_qz._yzxk': 'Weltraum',

  '_qz._yl': 'Vorschau',

  '_qz._xzqz': 'Hintergrundbild herunterladen',

  '_qz._fbl': 'Auflösung',

  '_qz._fl': 'Kategorie',

  '_qz._jzz': 'Wird geladen',

  '_qz._myzdpp': 'Keine passenden Hintergrundbilder gefunden',

  '_sp._xyjscl': 'Entsperren zum Ansehen erforderlich',

  '_sp._cz': 'Aufladen, _sp._jsqj: Alle Folgen freischalten',

  '_sp._jsbj': 'Diese Folge freischalten',

  '_sp._sc': 'Zu Favoriten hinzufügen',

  '_sp._fx': 'Teilen',

  '_sp._jsqjjs': 'Zahlung für {a} bestätigen und alle Folgen freischalten?',

  '_sp._jsbjjs': 'Zahlung für {a} bestätigen und alle freischalten Folgen?',

  '_sp._zfz': 'Zahlung läuft...',

  '_sp._qrzf': 'Zahlung bestätigen',

  '_sp._qx': 'Abbrechen',

  '_qz._smrc': 'Sonnenaufgang über den Bergen',

  '_qz._cxjh': 'Abstrakte Geometrie',

  '_qz._dsyj': 'Nachtansicht der Stadt',

  '_qz._dmfj': 'Anime-Szenerie',

  '_qz._hhxk': 'Weitläufiger Sternenhimmel',

  '_qz._slmw': 'Waldnebel',
  '_qz._scld': 'Farbverlauf',

  '_qz._xdjz': 'Moderne Architektur',

  '_qb._cbjl': 'Einzahlungsbelege',

  '_qb._jyjl': 'Transaktion" Datensätze',

  '_qb._bddz': 'Gebundene Adresse',

  '_qb._txjl': 'Auszahlungsdatensätze',

  '_m._tcdl': 'Abmelden',

  '_m._cb': 'Einzahlung',

  '_m._tb': 'Auszahlung',

  '_cb._ssdz': 'Währung oder Adresse suchen',

  '_cb._bz': 'Währung',

  '_cb._je': 'Betrag',

  '_cb._dz': 'Adresse',

  '_cb._sj': 'Zeitpunkt',

  '_cb._cz': 'Vorgang',

  '_cb._zwjl': 'Keine Transaktionsdatensätze',
  '_cb._dny': 'Seite {a} von {b}',

  '_cb._jyxq': 'Transaktionsdetails',

  '_cb._jydz': 'Transaktionsadresse',

  '_cb._zt': 'Status',

  '_cb._yqr': 'Bestätigt',

  '_cb._qb': 'Alle',

  '_cb._jt': 'Heute',

  '_cb._j7t': 'Letzte 7 Tage',

  '_cb._j30t': 'Letzte 30 Tage',

  '_cb._zw': 'Keine',

  '_cb._fzcg': 'Adresse in die Zwischenablage kopiert',

  '_jyjl._ssdz': 'Währung oder Adresse suchen',

  '_jyjl._lx': 'Typ',

  '_jyjl._je': 'Betrag',

  '_jyjl._ye': 'Saldo',
  '_jyjl._dj': 'Gesperrt',

  '_jyjl._sj': 'Zeit',

  '_jyjl._cz': 'Operation',

  '_jyjl._zwjyjl': 'Keine Transaktion Datensätze',

  '_jyjl._czsx': 'Filter zurücksetzen',

  '_jyjl._dny': 'Seite {a} von {b}',

  '_jyjl._jyxq': 'Transaktionsdetails',

  '_jyjl._jylx': 'Transaktionstyp',

  '_jyjl._jyje': 'Transaktionsbetrag',

  '_jyjl._jyhye': 'Saldo nach Transaktion',

  '_jyjl._djye': 'Gesperrter Betrag',

  '_jyjl._jysj': 'Transaktionszeitpunkt',

  '_jyjl._jyzt': 'Transaktionsstatus',

  '_jyjl._ywc': 'Abgeschlossen',

  '_jyjl._qb': 'Alle',

  '_jyjl._jt': 'Heute',

  '_jyjl._j7t': 'Letzte 7 Tage',

  '_jyjl._j30t': 'Letzte 30 Tage',

  '_jyjl._tp1': 'Einzahlung',

  '_jyjl._tp2': 'Auszahlung',

  '_jyjl._tp3': 'Zahlung',

  '_jyjl._tp4': 'Einzahlung',

  '_jyjl._tp5': 'Gesperrt',

  '_jyjl._tp6': 'Einnahmen',

  '_jyjl._tp7': 'Einladungsprämien',

  '_jyjl._tp8': 'Anmeldeprämien',

  '_jyjl._tp9': 'Empfehlungsprämien',

  '_jyjl._tp10': 'Belohnungen für Videoaufrufe',
  '_jyjl._tp11': 'Registrierungsbonus',
  '_jyjl._tp12': 'Auszahlung abgelehnt',
  '_jyjl._tp13': 'Nachrichtenpaket (rot)',

  '_jyjl._tp14': 'Interne Übertragung',

  '_cb._shz': 'In Bearbeitung',

  '_cb._yyg': 'Genehmigt',

  '_cb._ybh': 'Abgelehnt',

  '_bddz._tjdz': 'Adresse hinzufügen',

  '_bddz._ssdz': 'Adresse suchen',

  '_bddz._bz': 'Währung',

  '_bddz._dz': 'Adresse',

  '_bddz._sysj': 'Nutzungszeit',

  '_bddz._cz': 'Vorgang',

  '_bddz._zwjl': 'Keine Adressdatensätze',

  '_bddz._dny': 'Seite {a} von {b}',

  '_bddz._dzewm': 'QR-Code der Adresse',

  '_bddz._fzdz': 'Adresse kopieren',
  '_bddz._dzxq': 'Adressdetails',

  '_bddz._wl': 'Netzwerk',

  '_bddz._tjsj': 'Hinzugefügte Zeit',

  '_bddz._bzwa': 'Bemerkungen',

  '_bddz._ntq': 'Vor {a} Tagen',

  '_bddz._nxsq': 'Vor {a} Stunden',

  '_bddz._nfzq': 'Vor {a} Minuten',

  '_bddz._ngg': 'Gerade eben',

  '_bddz._dzyfz': 'Adresse in die Zwischenablage kopiert',

  '_bddz._scqr': 'Löschbestätigung',

  '_bddz._scqrdz': 'Möchten Sie diese Adresse wirklich löschen?',

  '_bddz._qr': 'Bestätigen',

  '_bddz._qx': 'Abbrechen',

  '_bddz._scdzcg': 'Adresse erfolgreich gelöscht',

  '_txjl._ztsx': 'Statusfilter',

  '_txjl._qbzt': 'Alle Status',

  '_txjl._shz': 'In Bearbeitung',

  '_txjl._ytg': 'Genehmigt',

  '_txjl._yjj': 'Abgelehnt',

  '_txjl._ssdz': 'Adresse oder Betrag suchen',

  '_txjl._bz': 'Währung',

  '_txjl._je': 'Betrag',

  '_txjl._dz': 'Adresse',

  '_txjl._zt': 'Status',

  '_txjl._sj': 'Zeit',

  '_txjl._cz': 'Vorgang',

  '_txjl._zwjl': 'Keine Transaktionsdatensätze',

  '_txjl._czsx': 'Filter zurücksetzen',

  '_txjl._dny': 'Seite {a} von {b}',

  '_txjl._jyxq': 'Transaktionsdetails',

  '_txjl._skdz': 'Zahlungsadresse',

  '_txjl._jysj': 'Transaktionszeit',

  '_txjl._jyzt': 'Transaktionsstatus',

  '_txjl._fzdz': 'Adresse in die Zwischenablage kopiert',
  '_cbsq._bz': 'Währung',

  '_cbsq._wl': 'Netzwerk',

  '_cbsq._erwm': 'QR-Code',

  '_cbsq._fzdz': 'Adresse kopieren',

  '_txsq._bz': 'Währung',

  '_txsq._wl': 'Netzwerk',

  '_txsq._ye': 'Kontostand',

  '_txsq._sxf': 'Transaktionsgebühr',

  '_txsq._zxtx': 'Mindestauszahlungsbetrag',

  '_txsq._txdz': 'Auszahlungsadresse',

  '_txsq._qxztxdz': 'Bitte wählen Sie eine Auszahlungsadresse',

  '_txsq._txje': 'Auszahlungsbetrag',

  '_txsq._qsrtxje': 'Bitte geben Sie den Auszahlungsbetrag ein." Betrag',

  '_txsq._yxyzm': 'E-Mail-Bestätigungscode',
  '_txsq._qsryxyzm': 'Bitte geben Sie den Bestätigungscode ein',

  '_txsq._ljtx': 'Sofort auszahlen',

  '_jl._wxhd': 'Meine Favoriten',

  '_jl._lsjl': 'Verlauf',

  '_xx._bt': 'Nachrichtencenter',

  '_xx._wjl': 'Keine Einträge',

  '_xx._zsmyxx': 'Derzeit keine Nachrichten',

  '_xx._sxxx': 'Nachrichten aktualisieren',

  '_xx._sxcg': 'Aktualisierung erfolgreich',

  '_fx._fxhy': 'Mit Freunden teilen',

  '_fx._smfx': 'QR-Code scannen, um mit Freunden zu teilen',

  '_fx._jlsm': 'Prämien" Erklärung',

  '_fx._jlsm1': '1. Für Freunde, die du direkt einlädst (Level 1), erhältst du {a}% ihrer Einnahmen.',
  '_fx._jlsm2': '2. Wenn dein Level-1-Freund weitere Freunde (Level 2) einlädt, erhältst du {a}% seiner Einnahmen.',

  '_fx._jlsm3': '3. Wenn dein Level-2-Freund weitere Freunde (Level 3) einlädt, erhältst du {a}% seiner Einnahmen.',

  '_fx._fzlj': 'Link kopieren',

  '_bzzx._bzzx': 'Hilfezentrum',

  '_bzzx._rhzczh': 'So registrierst du ein Konto',

  '_bzzx._zclc': 'Registrierungsprozess',

  '_bzzx._rhzcxyh': 'So registrierst du ein neues Konto?',

  '_bzzx._rhzcxyh1': "Klicken Sie auf den Button 'Registrieren', geben Sie Ihre E-Mail-Adresse ein, legen Sie ein Passwort fest und schließen Sie die E-Mail-Verifizierung ab, um Ihr Konto erfolgreich zu registrieren.",

  '_bzzx._rhcz': 'Wie lade ich mein Guthaben auf?',
  '_bzzx._rhcz1': 'Aufladevorgang',

  '_bzzx._rhcz2': 'Detaillierte Aufladeanleitung',

  '_bzzx._rhcz3': "Klicken Sie auf 'Meine Wallet', 'Einzahlen', wählen Sie die Kryptowährung aus, die Sie einzahlen möchten, und überweisen Sie sie an die angegebene Adresse.",

  '_bzzx._rhjsdj': 'So schaltest du Kurzfilme frei',

  '_bzzx._rhjsdj2': 'Klicken Sie auf eine einzelne Folge, um die Handlung freizuschalten und weitere spannende Inhalte zu sehen.',

  '_bzzx._rhtx': 'So heben Sie Guthaben von Ihrem Konto ab',

  '_bzzx._rhtx1': '1. Klicken Sie auf ‚Meine Wallet‘, ‚Auszahlungsadresse‘ und fügen Sie eine entsprechende Kryptowährungs-Auszahlungsadresse hinzu.<br>2. Klicken Sie auf ‚Auszahlen‘, wählen Sie die entsprechende Kryptowährung und die verknüpfte Adresse aus, geben Sie den Auszahlungsbetrag ein und warten Sie, bis das Geld eingegangen ist.',

  '_bzzx._qtwt': 'Weitere Fragen',

  '_bzzx._qtwt1': 'Wie kann ich den Kundenservice kontaktieren?',

  '_bzzx._qtwt2': 'Sie können uns über den Online-Kundenservice in der unteren rechten Ecke der Webseite, per E-Mail oder über unsere Hotline erreichen.',

  '_bzzx._myzdwt': 'Haben Sie die gesuchte Antwort nicht gefunden?',

  '_bzzx._khjybbzn': 'Unser Kundenservice-Team hilft Ihnen gerne weiter.',

  '_bzzx._lxkf': 'Kundenservice kontaktieren',

  '_ggtf._bt1': 'Werbeplatzierung',

  '_ggtf._splb': 'Videoliste',

  '_ggtf._wcyd': 'Meine Teilnahmen',

  '_ggtf._hdbm': 'Aktivitätscode',

  '_ggtf._tian': 'Tag',

  '_ggtf._kssj': 'Startzeit',

  '_ggtf._jssj': 'Endzeit',
  '_ggtf._ddvp': 'VIP-Status erreicht, durchschnittliche Teilnahmen pro Person: {b} Mal',

  '_ggtf._hdzt': 'Aktivitätsstatus',

  '_ggtf._wks': 'Nicht gestartet',

  '_ggtf._ycy': 'Teilgenommen',

  '_ggtf._qg': 'Flash Verkauf',

  '_ggtf._mygdl': 'Nicht mehr verfügbar',

  '_ggtf._qgrtd': 'Zu viele Teilnehmer, bitte versuchen Sie es erneut',

  '_ggtf._hdxq': 'Details zur Aktivität',

  '_ggtf._hdjs': 'Einführung in die Aktivität',

  '_ggtf._cyyq': 'Teilnahmevoraussetzungen',

  '_ggtf._zdtz': 'Mindestinvestition',

  '_ggtf._vpdj': 'VIP-Stufe',

  '_ggtf._rjcy': 'Durchschnittliche Teilnehmerzahl pro Person',

  '_ggtf._gmje': 'Kaufbetrag',
  '_ggtf._qsrgmje': 'Bitte geben Sie den Kaufbetrag ein',

  '_ggtf._qx': 'Abbrechen',

  '_ggtf._ljcy': 'Teilnehmen" Jetzt',

  '_ggtf._ssjymm': 'Transaktionspasswort eingeben',

  '_ggtf._qssjymm': 'Bitte geben Sie das Transaktionspasswort ein',

  '_ggtf._ji': 'Stufe',

  '_ggtf._ci': 'Anzahl',

  '_ggtf._zdgm': 'Mindestkaufbetrag',

  '_ggtf._zggm': 'Höchstkaufbetrag',

  '_ggtf._zfz': 'Zahlung läuft...',

  '_wdtg._wjl': 'Noch keine Teilnahmedaten',

  '_wdtg._tzje': 'Investitionsbetrag',

  '_wdtg._zsy': 'Gesamtertrag',

  '_wdtg._hdts': 'Anzahl der Aktivitätstage',
  '_wdtg._cysj': 'Teilnahme Zeit',

  '_wdtg._qzf': 'Zur Zahlung',

  '_wdtg._jxz': 'In Bearbeitung',

  '_wdtg._djszje': 'Gesamtbetrag ausstehend',

  '_wdtg._gjb': 'Anzahl {a} Transaktionen',

  '_wdtg._djs': 'Ausstehende Abrechnung',

  '_wdtg._zrsy': 'Einnahmen von gestern',

  '_wdtg._dbl': 'Aufrufe',

  '_wdtg._bfl': 'Wiedergaben',

  '_wdtg._wdsy': 'Meine Einnahmen',

  '_wdtg._bqffc': 'Anteil des Urheberrechtsinhabers',

  '_wdtg._mr0djs': 'Abgerechnete Einnahmen von gestern um 00:00 Uhr täglich',

  '_wdtg._jrsy': 'Heutige Einnahmen',

  '_wdtg._mygd': 'Nicht mehr',

  '_bqyy._bqyy': 'Termin für die Urheberrechtskooperation',

  '_bqyy._qrbq': 'Termin für die Urheberrechtskooperation bestätigen?',

  '_bqyy._qx': 'Abbrechen',

  '_bqyy._tjyy': 'Termin einreichen',

  '_bqyy._spsq': 'Termin für die Video-Urheberrechtskooperation',

  '_bqyy._spsy': 'Bewerben Sie Ihre Videos bei Urheberrechtsinhabern und generieren Sie mehr Traffic und Umsatz!',

  '_bqyy._ljyy': 'Jetzt Termin vereinbaren',

  '_bqyy._sphz': 'Was ist eine Video-Urheberrechtskooperation?',

  '_bqyy._sphzsm': 'Eine Anwendung zur Zusammenarbeit im Bereich Videorechte ermöglicht eine intensivere Kooperation für beiderseitig vorteilhafte Ergebnisse. Durch die Anwendung gewinnen Sie die Anerkennung von Rechteinhabern und haben die Möglichkeit, eng mit ihnen zusammenzuarbeiten, wodurch Sie mehr Reichweite und Einnahmen erzielen.',

  '_bqyy._sqhch': 'Vorteile der Beantragung einer Urheberrechtskooperation',
  '_bqyy._llfz': 'Unterstützung des Traffics',

  '_bqyy._llfzsm': 'Nutzen Sie die Möglichkeiten zur Plattformwerbung, erhöhen Sie Ihre Reichweite und Aufrufe',

  '_bqyy._sytg': 'Steigerung der Einnahmen',

  '_bqyy._sytgsm': 'Höhere Werbeeinnahmenbeteiligung und Möglichkeiten zur Geschäftspartnerschaft',

  '_bqyy._yxhz': 'Priorisierte Zusammenarbeit',

  '_bqyy._yxhzsm': 'Vorrangige Teilnahme an offiziellen Plattformaktivitäten und Projekten zur Geschäftspartnerschaft',

  '_bqyy._yytj': 'Reservierungsanforderungen',

  '_bqyy._sptg': 'Anforderungen an die Videowerbung',

  '_bqyy._sptgsm': 'Teilnahme an mindestens "Eine Video-Promotion, die den Plattformstandards entspricht',

  '_bqyy._yysm': "Nachdem Sie auf 'Reservieren' geklickt haben, wird sich unser Team innerhalb von 3 Werktagen mit Ihnen in Verbindung setzen",

  '_ybp._wdsy': 'Meine Einnahmen',
  '_ybp._dqye': 'Aktueller Kontostand',

  '_ybp._jr': 'Heutige Einnahmen',

  '_ybp._jrzsy': 'Heutige Gesamteinnahmen',

  '_ybp._ljzsy': 'Kumulierte Gesamteinnahmen',

  '_ybp._tgfh': 'Empfehlungsbonus',

  '_ybp._ljsy': 'Kumulierte Einnahmen',

  '_ybp._bqsy': 'Urheberrechtseinnahmen',

  '_ybp._yqfh': 'Empfehlungsbonus',

  '_ybp._mrsy': 'Tägliche Einnahmen Einnahmen',

  '_ybp._tgsy': 'Empfehlungseinnahmen',

  '_tjdz._tjxd': 'Neue Adresse hinzufügen',

  '_tjdz._xzbz': 'Währung auswählen',

  '_tjdz._qbdz': 'Wallet-Adresse',

  '_tjdz._srdz': 'Bitte geben Sie Ihre Wallet-Adresse ein',
  '_tjdz._qx': 'Abbrechen',

  '_tjdz._bc': 'Speichern',

  '_sz._smrz': 'Authentifizierung mit Klarnamen',

  '_sz._rzlx': 'Authentifizierungstyp',

  '_sz._sfzzm': 'Ausweisfoto (Vorderseite)',

  '_sz._sfzfm': 'Ausweisfoto (Rückseite)',

  '_sz._zsxm': 'Echtname Name',

  '_sz._qsrzsxm': 'Bitte geben Sie Ihren echten Namen ein',

  '_sz._sfzhm': 'ID-Kartennummer',

  '_sz._qsrsfzhm': 'Bitte geben Sie die Ausweisnummer ein',

  '_sz._yyzz': 'Geschäftslizenz',

  '_sz._qymc': 'Firmenname',

  '_sz._yyzzh': 'Geschäftslizenznummer',

  '_sz._qsrqymc': 'Bitte Firmennamen eingeben',

  '_sz._qsryyzzh': 'Bitte geben Sie die Gewerbelizenznummer ein',

  '_sz._qx': 'Abbrechen',

  '_sz._tjrz': 'Zur Überprüfung einreichen',

  '_sz._zt': 'Status',

  '_sz._gr': 'Einzelperson',

  '_sz._qy': 'Unternehmen',

  '_sz._shz': 'Wird geprüft',

  '_sz._ytg': 'Genehmigt',

  '_sz._ybh': 'Abgelehnt',

  '_mm._xgmm': 'Passwort ändern',

  '_mm._dqxg': 'Ändern Sie Ihr Passwort regelmäßig, um die Kontosicherheit zu gewährleisten',

  '_mm._dqmm': 'Aktuelles Passwort',

  '_mm._xmm': 'Neues Passwort',

  '_mm._qrxmm': 'Neues Passwort bestätigen',

  '_mm._qx': 'Abbrechen',
  '_mm._qrxg': 'Änderungen bestätigen',

  '_jymm._xgjymm': 'Transaktionspasswort ändern',

  '_szzx._sz': 'Einstellungen',

  '_szzx._yrz': 'Authentifiziert',

  '_szzx._wrz': 'Nicht authentifiziert',

  '_szzx._jymm': 'Transaktion Passwort',

  '_szzx._szjymm': 'Transaktionspasswort festlegen oder ändern',

  '_szzx._tcdl': 'Abmelden',

  '_szzx._qdtcdl': 'Möchten Sie sich wirklich abmelden?',

  '_szzx._qrtc': 'Abmeldung bestätigen',

  '_szzx._qx': 'Abbrechen',

  '_yj._gy': 'Über uns',

  '_yj._lxwm': 'Kontakt',

  '_yj._yszc': 'Datenschutzrichtlinie',

  '_yj._yhxy': 'Nutzungsbedingungen',

  '_cd._gszz': 'Unternehmensqualifikationen',

  '_cd._wmyy': 'Wir verfügen über alle branchenüblichen Qualifikationen und Zertifizierungen und bieten Nutzern legale, sichere und qualitativ hochwertige Videodienste',

  '_cd._yyzz': 'Gültiger Nachweis der rechtmäßigen Geschäftstätigkeit des Unternehmens, der unsere formellen Registrierungsinformationen und unseren Geschäftsbereich belegt',

  '_cd._yyzz2': 'Eine rechtmäßig erworbene, vom Unternehmen zertifizierte Geschäftslizenz, die die Rechtmäßigkeit und Konformität der Plattform gewährleistet',

  '_bz._lxkf': 'Klicken Sie unten, um den Kundenservice zu kontaktieren, oder kontaktieren Sie uns per E-Mail oder Hotline',

  '_sz._bjtx': 'Bearbeiten',

  '_sz._bjxx': 'Nachricht bearbeiten',

  '_sz._tx': 'Avatar',

  '_sz._bcun': 'Speichern',

  '_db._zskf': 'Support kontaktieren',
  '_db._zsry': 'Persönlicher Ansprechpartner',
  '_db._wdq': 'Ungelesen',
  '_db._ydq': 'Gelesen',

  '_sc._sctp': 'Bild hochladen',
  '_sc._xztp': 'Bild auswählen',
  '_sc._fstp': 'Bild senden',
  '_sc._qx': 'Abbrechen',
  '_sc._hd': 'Okay',

  '_zcyl._zcbt': 'Registrierungsbonus',
  '_zcyl._djdkhb': 'Zum Öffnen tippen',
  '_zcyl._zclj': 'Registrierungsprämie',
  '_zcyl._hmyzh': 'Noch kein Konto?',
  '_zcyl._qzc': 'Jetzt registrieren',
  '_zcyl._qxdjhb': 'Bitte zuerst Prämie einlösen',
  '_zcyl._qwzc': 'Zur Registrierung',
  '_zcyl._hbysy': 'Prämie bereits verwendet',

  '_ggtg._qhz': 'Zur Überweisung',
  '_ggtg._dqye': 'Aktueller Kontostand',
  '_ggtg._qcz': 'Aufladen',
  '_ggtg._hzje': 'Überweisungsbetrag',
  '_ggtg._ljhz': 'Sofort überweisen',
  '_ggtg._yebz': 'Unzureichendes Guthaben',

  '_sq._bhbt': 'Abgelehnt',

  '_sq._bhyy': 'Grund für die Ablehnung',

  '_xx._ntq': 'Vor {n} Tagen',

  '_xx._nxsq': 'Vor {n} Stunden',

  '_xx._nfzq': 'Vor {n} Minuten',

  '_xx._nggq': 'Gerade eben',

  '_xx._djckgd': 'Klicken Sie hier, um mehr anzuzeigen',

  '_ct._zt': 'Status',

  '_ct._ljz': 'Verbinden',

  '_ct._ylj': 'Verbunden',

  '_ct._ltlieb': 'Chatliste',

  '_ct._bnhzj': 'Kann nicht mit mir selbst chatten',

  '_ct._cylb': 'Mitgliederliste',

  '_hb._fhb': 'Roter Umschlag',

  '_hb._dqye': 'Aktueller Kontostand',

  '_hb._fsd': 'Gesendet an',

  '_hb._hbje': 'Betrag für den roten Umschlag',

  '_hb._qshuru': 'Bitte geben Sie den Betrag für den roten Umschlag ein',

  '_hb._ljfs': 'Jetzt senden',

  '_hb._hbz': "Roter Umschlag' Segen",
  '_hb._qshuruzhu': 'Bitte geben Sie Ihren Segen ein',

  '_sp._cuow': 'Die Folgen 1-10 müssen freigeschaltet werden, bevor Sie sie ansehen können',

  '_bq._tzzq': 'Investitionszeitraum',

  '_bq._zrsy': 'Gewinn von gestern',

  '_bq._bqtz': 'Urheberrechtsinvestition',

  '_bq._tzdj': 'Investitionsbetrag',

  '_bq._zfjz': 'Die Zahlung muss innerhalb von 24 Stunden erfolgen, andernfalls gilt sie als Verzicht!',

  '_bq._qzf': 'Zahlung durchführen',

  '_bq.jz': 'Frist',

  '_bq._ljzf': 'Jetzt bezahlen',

  '_bq._sqbz': 'Anmerkungen zur Anwendung (optional)',

  '_bq._sqbzsm': 'Bitte geben Sie Anmerkungen zur Anwendung ein',

  '_bq._zzsqz': 'Urheberrechtsanmeldung läuft, wird noch geprüft...',

  '_app._xz': 'ReelShortBiz-Anwendung herunterladen',

  '_app._smerm': 'QR-Code scannen zum Herunterladen',

  '_app._xzbt': 'App herunterladen',

  '_m._yhzz': 'Banküberweisung',
  '_m._yhxx': 'Bankinformationen',
  '_m._yhmz': 'Bankname',
  '_m._yhdz': 'Bankadresse',
  '_m._yhmc': 'Name',
  '_m._yhzh': 'Konto',
  '_m._yhlx': 'Typ',
  '_m._yhly': 'Routing',
  '_m._yhdm': 'Code',
  '_m._yhbz': 'Notiz',
  '_m._fzxx': 'Info kopieren',

  '_m._zts': 'Tipps',

  '_m._zyd1': '1. Bitte überprüfen Sie bei der Überweisung sorgfältig den Namen des Empfängers, die Kontonummer und die Bankleitzahl. Fehler können zum Verlust der Überweisung führen.',

  '_m._zyd2': "2. Wir empfehlen die Option 'Absender trägt alle Gebühren', um zu vermeiden, dass durch zwischengeschaltete Banken Gebühren anfallen.",

  '_m._zyd3': '3. Überweisungen dauern in der Regel 1–3 Werktage. Bitte haben Sie Geduld. Bei Fragen wenden Sie sich bitte an unseren Kundenservice.',

  '_m._zyd4': '4. Bei weiteren Fragen wenden Sie sich bitte an unseren Kundenservice.',

  '_m._jyh': 'Transaktionsnummer',

  '_m._jyje': 'Betrag',

  '_sp._dbye': 'VOD-Guthaben',
  '_sp.hzye': 'Transfer',
  '_sp._txje': 'Transferbetrag',
  '_sp._qsrtxje': 'Bitte geben Sie den Transferbetrag ein',
  '_sp._ljhz': 'Jetzt transferieren',
  '_sp._yebz': 'Unzureichendes Guthaben',
  '_sp._qshuru': 'Bitte geben Sie den korrekten Transferbetrag ein',
  '_sp._fanh': 'Zurück',

  '_sp._tliu': 'Werbeschaltung',
  '_sp._xzgj': 'Land auswählen',
  '_sp._cdcw': 'Videokodierungsfehler',
  '_ggtf._hot': 'Heiß',
  '_tl._tlsj': 'Werbeschaltungszeit',
  '_tl._xzxb': 'Geschlecht auswählen',
  '_tl._nan': 'Männlich',
  '_tl._nv': 'Weiblich',
  '_tl._hunhe': 'Gemischt',
  '_tl._xznl': 'Alter auswählen',
  '_sp._us': 'Vereinigte Staaten',
  '_sp._en': 'Vereinigtes Königreich',
  '_sp._jp': 'Japan',
  '_sp._fr': 'Frankreich',
  '_sp._kr': 'Südkorea',
  '_sp._de': 'Deutschland',
  '_sp._id': 'Indien',
  '_sp._in': 'Indonesien',
  '_sp._au': 'Australien',
  '_sp._es': 'Spanien',
  '_sp._my': 'Malaysia',
  '_sp._cn': 'China',
  '_ggtf._fanhui': 'Zurück',
  '_ggtf._jymmts': 'Bitte bestätigen Sie den Transaktionsbetrag und geben Sie Ihr Passwort ein',
  '_wdtg._wjl_desc': 'Sie haben noch an keiner Werbekampagne teilgenommen',
  '_wd._jxz': 'In Bearbeitung',
  '_wd._djs': 'Ausstehende Abrechnung',
  '_wd._ywc': 'Abgeschlossen',
  '_wd._jz': 'Dringend',
  '_wd._hz': 'Überweisung',

  '_tl._tlfbqk': 'Verteilung der Werbeausgaben',
  '_tl._tlfbqk_desc': 'Tag 1-5: 5% (Kaltstartphase), Tag 6-10: 20% (Inhaltsvalidierungsphase), Tag 11-15: 40% (IP-Aufbauphase), Tag 16-20: 35% (Kurzserien-Matrixphase)',

  '_nhz._sm': 'Nach der Überweisung wird der Betrag auf die Video-Wallet gutgeschrieben, um Videoinhalte freizuschalten',
  '_nhz._zhzz': 'Überweisung läuft...',
  '_nhz._zzcg': 'Überweisung erfolgreich',
  '_nhz._zhzsb': 'Überweisung fehlgeschlagen, bitte erneut versuchen',
  '_m._fzcg': 'Erfolgreich kopiert',
  '_m._fzsb': 'Kopieren fehlgeschlagen, bitte manuell kopieren',
  '_m._zwfzxx': 'Keine Informationen zum Kopieren',
  '_tx._qb': 'Alle',
  'activity.detail': 'Aktivitätsdetails',
  'activity.noDesc': 'Keine Aktivitätsbeschreibung',
  'activity.desc': 'Aktivitätsbeschreibung',
  'activity.requirements': 'Teilnahmevoraussetzungen',
  'activity.minInvest': 'Mindestinvestition',
  'activity.vipLevel': 'VIP-Level',
  'activity.avgParticipation': 'Durchschnittliche Teilnahme',
  'activity.avgParticipationDesc': 'Mal',
  'activity.country': 'Land auswählen',
  'activity.deliveryTime': 'Werbezeit',
  'activity.deliveryTimeDesc': 'Tage',
  'activity.gender': 'Geschlecht auswählen',
  'activity.male': 'Männlich',
  'activity.female': 'Weiblich',
  'activity.mixed': 'Gemischt',
  'activity.age': 'Alter auswählen',
  'activity.amount': 'Kaufbetrag',
  'activity.back': 'Zurück',
  'activity.join': 'Jetzt teilnehmen',
  emptyData: 'Keine Daten',
  emptyDataDesc: 'Keine teilnehmenden Werbekampagnen',
  completedtlement: 'Abgelaufen',
  preheat: 'Vorheizen',
  progress: 'In Bearbeitung',
  settlement: 'Ausstehende Abrechnung',
  transfered: 'Übertragen',
  completed: 'Abgeschlossen',
  activityCode: 'Aktivitätscode',
  touzAmount: 'Investitionsbetrag',
  activityDays: 'Aktivitätstage',
  joinTime: 'Teilnahmezeit',
  playSource: 'Wiedergabequellenverteilung',
  allPlatforms: 'Alle Plattformen',
  other: 'Andere',
  totalPlayNum: 'Gesamtaufrufe',
  incomeSummary: 'Einkommenszusammenfassung',
  totalPay: 'Urheberrechtsgebühren',
  totalIncome: 'Gesamteinnahmen',
  copyrightRatio: 'Anteil des Rechteinhabers',
  promotionIncome: 'Werbeeinnahmen',
  copyrightIncome: 'Urheberrechtsanteil',
  playNum: 'Aufrufe',
  buyNum: 'Abrufaufrufe',
  incomeRate: 'Verteilungsanteil',
  yjIncome: 'Geschätztes Einkommen',
  paid: 'Bezahlt',
  timeout: 'Zeitüberschreitung',
  transfer: 'Jetzt übertragen',
  loading: 'Lädt...',
  loadMore: 'Mehr laden',
  noMore: 'Keine weiteren',
  nightTime: 'Nachtzeitraum',
  morningTime: 'Morgenzeitraum',
  afternoonTime: 'Nachmittagszeitraum',
  eveningTime: 'Abendzeitraum',
  '_h._tc': 'Abmelden',
  periodPayment: 'Zeitraumzahlung',
  periodPaymentDesc: 'Die Abrechnung erfolgt 4-mal täglich in 4 Zeiträumen, Sie können die Urheberrechtsgebühren pro Zeitraum bezahlen',

  day: 'Tag',
  '_dl._hy': 'Willkommen zurück',
  '_dl._cj': 'Konto erstellen',
  '_dl._zmm': 'Passwort zurücksetzen',
  '_dl._hyDesc': 'Melden Sie sich an, um weiterhin spannende Inhalte zu entdecken',
  '_dl._cjDesc': 'Treten Sie ReelShortBiz bei und beginnen Sie Ihre aufregende Reise',
  '_dl._zmmDesc': 'Geben Sie Ihre E-Mail ein, wir senden Ihnen einen Bestätigungscode zum Zurücksetzen',
  '_dl._hlgqsp': 'Umfangreiche HD-Film- und Videoressourcen',
  '_dl._gxhty': 'Personalisierte Empfehlungsalgorithmen',
  '_dl._ffddsp': 'Vielfältige Kurzvideos',
  '_dl._dlzh': 'Anmelden',
  '_dl._sdndyx': 'Geben Sie Ihre E-Mail und Ihr Passwort ein, um fortzufahren',
  '_dl._email': 'E-Mail-Adresse',
  '_dl._qsryx': 'Bitte geben Sie Ihre E-Mail-Adresse ein',
  '_dl._dlmm': 'Passwort',
  '_dl._qsrmm': 'Bitte geben Sie Ihr Passwort ein',
  '_dl._wjmm': 'Passwort vergessen?',
  '_dl._immdl': 'Jetzt anmelden',
  '_dl._hmyzh2': 'Noch kein Konto?',
  '_dl._ljzc2': 'Jetzt registrieren',
  '_dl._cjzh': 'Konto erstellen',
  '_dl._jswmd': 'Treten Sie ReelShortBiz bei und beginnen Sie Ihre aufregende Reise',
  '_zh._qszmm': 'Bitte legen Sie Ihr Passwort fest',
  '_zh._qrmm': 'Passwort bestätigen',
  '_zh._qmm': 'Bitte geben Sie das Passwort erneut ein',
  '_zc._yqm': 'Einladungscode',
  '_zc._sryqm': 'Bitte geben Sie den Einladungscode ein',
  '_dl._yzm': 'Bestätigungscode',
  '_dl._qsryzm': 'Bitte geben Sie den Bestätigungscode ein',
  '_dl._yjyzh': 'Bereits ein Konto?',
  '_dl._zcbsty2': 'Mit der Registrierung stimmen Sie zu',
  '_dl._zcbstyDesc': 'Datenschutzrichtlinie',
  '_dl._newmm': 'Neues Passwort',
  '_dl._qszxmm': 'Bitte legen Sie ein neues Passwort fest',
  '_dl._qrmm': 'Passwort bestätigen',
  '_dl._qzcsrmm': 'Bitte geben Sie das neue Passwort erneut ein',
  '_dl._czmm': 'Passwort zurücksetzen',
  '_dl._xqlmm': 'Passwort wieder eingefallen?',
  '_dl._fhdl': 'Zurück zur Anmeldung',
  '_dl._srdllmmbyz': 'Die Passwörter stimmen nicht überein',
  '_dl._czcg': 'Passwort erfolgreich zurückgesetzt',
  '_h._zc': 'Registrieren',
  // '_ybp._wdsy': 'Meine Einnahmen',
  '_ybp._jrsy': 'Heutige Einnahmen',
  '_ybp._jztr': 'Im Vergleich zu gestern',
  '_ybp._bfl': 'Aufrufe',
  '_ybp._dbl': 'Abrufe',
  '_ybp._syqs': 'Einnahmentrend',
  // '_ybp._jr': 'Heute',
  '_ybp._t': 'Tag',
  // '_ybp._dqye': 'Kontostand',
  '_ybp._djs': 'Ausstehende Abrechnung',
  '_ybp._zhl': 'Konversionsrate',
  '_ybp._sjgl': 'Datenübersicht',
  '_ybp._zrsy': 'Einnahmen von gestern',
  '_ybp._bysy': 'Einnahmen diesen Monat',
  '_ybp._yysj': 'Betriebsdaten',
  '_ybp._zr': 'Gestern',
  '_ybp._zjfrs': 'Bezahlte Nutzer gesamt',
  '_ybp._mtdqje': 'Morgen fälliger Betrag',
  '_ybp._jsy': 'Nettoeinnahmen',
  '_ybp._bqfy': 'Zahlungsplan für Urheberrechtsgebühren',
  '_ybp._yzf': 'Bezahlt',
  '_ybp._qzf': 'Zur Zahlung',
  '_ybp._bqfyts': 'Nach Zahlung der Urheberrechtsgebühren werden Ihre Einnahmen und Rechte priorisiert',
  '_ybp._syjl': 'Einnahmenverlauf',
  '_ybp._ckgd': 'Mehr anzeigen',
  '_ybp._ssdt': 'Live-Updates',
  '_ybp._bzzx': 'Hilfezentrum',
  '_ybp._lxkf': 'Kundenservice kontaktieren',
  '_ybp._zrxz': 'Einnahmen von gestern',
  '_ybp._zdsy': 'Gesamteinnahmen',
  '_ybp._qygy': 'Letzter Monat',
  '_ybp._jsjl': 'Abrechnungsverlauf',
  '_ybp._hzjl': 'Überweisungsverlauf',
  '_ybp._jfzq': 'Minuten her',
  '_ybp._fzq': 'Stunden her',
  '_ybp._djs_mt': 'Abrechnungssumme morgen',
  '_yj._rule': 'Plattformregeln',

  '_bq._jjks': 'Jetzt starten',
  '_bq._jxz': 'Läuft',
  '_bq._jks': 'Bis zum Start',
  '_bq._jjs': 'Bis zum Ende',
  '_bq._t': 'T',
  '_bq._h': 'Std',
  '_bq._m': 'Min',
  '_bq._s': 'Sek',
  '_bq._kssj': 'Startzeit',
  '_bq._jssj': 'Endzeit',
  '_bqq._tzdj': 'Stückpreis',
  '_bqq._hdts': 'Aktionstage',
  '_bqq._vip': 'VIP-Stufe',
  '_bqq._rjcy': 'Teilnahme pro Person',
  '_bqq._cs': 'Mal',
  '_bqq._ysjd': 'Verkaufsfortschritt',
  '_bqq._ljqg': 'Jetzt kaufen',
  '_bqq._zbkqg': 'Derzeit nicht verfügbar',
  '_bqq._jzz': 'Lädt',
  '_bqq._jzgd': 'Mehr laden',
  '_bqq._wz': 'Keine weiteren Einträge',

  '_sp._gdsj': 'Insgesamt {n} Folgen',
  '_sy._jl': 'Ausstehende Abrechnungsaufzeichnung',
  '_ybp._zsy': 'Gesamteinnahmen',
  '_ybp._djsjl': 'Ausstehende Abrechnungsaufzeichnung',
  '_ybp._bqbm': 'Code',
  '_ybp._je': 'Betrag',
  '_ybp._sj': 'Zeit',
  '_sy._djs': 'Ausstehend',
  '_sy._yjs': 'Abgerechnet',
  '_sy._gdstjl': 'Insgesamt {n} Einträge',
  '_sy._gjd': 'Insgesamt {n}'
}
